/**
 * MoneyTabs — shared tab strip unifying the owner money pages into one
 * "Money hub": Revenue · Accounting · Pricing · Tax · Metrics · IOUs.
 * Owner-only pages, so no permission filtering needed beyond render guard.
 */
import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const TABS = [
    { to: "/coach/revenue", label: "Revenue" },
    { to: "/coach/accounting", label: "Accounting" },
    { to: "/coach/pricing-blocks", label: "Pricing" },
    { to: "/coach/tax-liability", label: "Tax" },
    { to: "/coach/metrics", label: "Metrics" },
    { to: "/coach/unsettled-ious", label: "IOUs" },
];

export default function MoneyTabs() {
    const { user } = useAuth();
    if (user?.role !== "owner") return null;
    return (
        <nav
            data-testid="money-tabs"
            className="flex items-center gap-1 overflow-x-auto -mx-1 px-1 pb-3 mb-4 border-b border-zinc-900"
        >
            {TABS.map((t) => (
                <NavLink
                    key={t.to}
                    to={t.to}
                    data-testid={`money-tab-${t.label.toLowerCase()}`}
                    className={({ isActive }) =>
                        `shrink-0 px-3.5 py-1.5 text-[11px] tracking-[0.18em] uppercase transition-colors border ${
                            isActive
                                ? "border-brand-red bg-brand-red/10 text-white"
                                : "border-transparent text-zinc-400 hover:text-white hover:border-zinc-700"
                        }`
                    }
                >
                    {t.label}
                </NavLink>
            ))}
        </nav>
    );
}
